import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import * as v from 'valibot'

import { companyDepartmentsQueries } from '@/http/api/companyDepartments'
import { userGroupQueries } from '@/http/api/usersGroups'
import { UserGroupDetailsMembersAdd } from '@/user-groups/components/UserGroupDetails/UserGroupDetailsMembers/UserGroupDetailsMembersAdd'

const defaultQueryValues = {
  candidate_status: [],
  candidate_department_id: '',
  candidate_license_provider_id: '',
}

const searchParamsSchema = v.object({
  candidate_status: v.optional(
    v.array(
      v.union([
        v.literal('active'),
        v.literal('pending'),
        v.literal('deactivated'),
      ]),
    ),
    defaultQueryValues.candidate_status,
  ),
  candidate_department_id: v.optional(
    v.string(),
    defaultQueryValues.candidate_department_id,
  ),
  candidate_license_provider_id: v.optional(
    v.string(),
    defaultQueryValues.candidate_license_provider_id,
  ),
})

export const Route = createFileRoute(
  '/company/_management/groups/$groupId/members/add',
)({
  component: RouteComponent,
  loaderDeps: ({
    search: {
      candidate_status,
      candidate_department_id,
      candidate_license_provider_id,
    },
  }) => ({
    candidate_status,
    candidate_department_id,
    candidate_license_provider_id,
  }),
  loader: async ({ context: { queryClient }, params, deps }) => {
    queryClient.prefetchQuery(companyDepartmentsQueries.list())
    await queryClient.prefetchInfiniteQuery(
      userGroupQueries.candidatesList(params.groupId, {
        size: 25,
        states: deps.candidate_status.length
          ? deps.candidate_status
          : undefined,
        department_id: deps.candidate_department_id || undefined,
        license_provider_id: deps.candidate_license_provider_id || undefined,
      }),
    )
  },
  validateSearch: searchParamsSchema,
  search: {
    middlewares: [stripSearchParams(defaultQueryValues)],
  },
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { groupId } = Route.useParams()
  const {
    candidate_status,
    candidate_department_id,
    candidate_license_provider_id,
  } = Route.useSearch()

  return (
    <UserGroupDetailsMembersAdd
      groupId={groupId}
      statusFilter={candidate_status}
      onStatusFilterChange={(values) => {
        navigate({ search: (prev) => ({ ...prev, candidate_status: values }) })
      }}
      departmentId={candidate_department_id}
      onDepartmentIdChange={(id) => {
        navigate({
          search: (prev) => ({ ...prev, candidate_department_id: id }),
        })
      }}
      licenseProviderId={candidate_license_provider_id}
      onLicenseProviderChange={(id) => {
        navigate({
          search: (prev) => ({
            ...prev,
            candidate_license_provider_id: id,
          }),
        })
      }}
      onClose={() => {
        navigate({ to: '/company/groups/$groupId/members' })
      }}
    />
  )
}
